
<div *ngIf="(getHighlightedItems?.length || 0) > 0; then collapsibleList else listGroup"></div>
  <ng-template #collapsibleList>
    <div class="sc-collapsible-list mb-6">
      <ul class="list-group-flush list-group list-type-bullet d-md-grid">
        <li *ngFor="let item of getHighlightedItems" class="list-group-item">{{item}}</li>
      </ul>
      <ng-template [ngIf]="getCollapsedItems?.length">
          <ul class="list-group more-tasks d-lg-block list-group-overflow list-type-bullet d-md-grid" [@animateInOut]="toggleState">
            <li *ngFor="let item of getCollapsedItems" class="list-group-item">{{item}}</li>        
          </ul>
          <button type="button" class="btn btn-outline-primary btn-block text-center mt-3 mb-3 d-lg-none" (click)="toggleList()" #toggleButton><span *ngIf="toggleState=='collapsed'">+{{ getCollapsedItems?.length }} weitere</span><span *ngIf="toggleState=='open'">weitere ausblenden</span></button>      
        </ng-template>
    </div>    
  </ng-template>

  <ng-template #listGroup>
      <ul class="list-group-flush list-group list-type-bullet mb-5 d-md-grid">
        <li *ngFor="let item of getCollapsedItems" class="list-group-item">{{item}}</li>
      </ul>    
  </ng-template>
